// extracted by mini-css-extract-plugin
export default {"outlet":"partners_outlet__gK4KV","title":"partners_title__c0gKe"};